import createCache, { EmotionCache } from '@emotion/cache';

export const EMOTION_CACHE_KEY = 'srv';
const createEmotionCache = (): EmotionCache => createCache({ key: EMOTION_CACHE_KEY, speedy: true, stylisPlugins: [] });

export default createEmotionCache;
